/* eslint-disable unicorn/no-unnecessary-polyfills */
/**
 * CoreJS polyfills. Based on Next.JS polyfill strategy and adapted to our needs (no need to polyfill IE11)
 * {@see https://github.com/vercel/next.js/blob/master/packages/next-polyfill-nomodule/src/index.js}
 */
/**
 * TODO: We should polyfill code automatically based on browserslist configuration and @babel/preset-env `useBuiltIns` option.
 *
 * @see https://babeljs.io/docs/babel-preset-env#usebuiltins
 * @see https://babeljs.io/docs/babel-preset-env#corejs
 * @see https://team-turo.atlassian.net/browse/SCHU-13463
 */
import "core-js/features/map";
import "core-js/features/symbol/async-iterator";
import "core-js/features/string/raw";
import "core-js/features/string/repeat";
import "core-js/features/string/trim-left";
import "core-js/features/string/trim-right";
import "raf/polyfill";
